<template>
  <b-modal
    :id="id"
    size="md"
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
    @ok="close"
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon icon="inbox-fill" aria-hidden="true"></b-icon>
        <span>{{ header }}</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel(), close()"
      >
        <base-icon name="close" width="14" height="14"/>
      </button>
    </template>
    <validation-observer style="padding-top: 1rem;" ref="observer2" v-slot="{ handleSubmit, invalid }">
      <p>{{ title }}</p>
      <div class="mt-2">
        <base-datepicker
          vid="from"
          name="da"
          label="Da"
          v-model="form.from"
          :rules="{ required: true }"
        />
      </div>
      <div class="mt-2">
        <base-datepicker
          vid="to"
          name="a"
          label="A"
          v-model="form.to"
          :rules="{ required: true }"
        />
      </div>

      <div class="mt-2">
        <base-select
          vid="salesmen"
          label="Produttori"
          name="produttori"
          :multiple="true"
          v-model="form.broker"
          :options="salesmen_select"
          :taggable="salesmen_taggable"
          :closeOnSelect="false"
          :rules="{ required: true }"
          :defaultHtmlMultipleSelect="true"
          @changeTaggable="changeTaggable"
        >
          <template #advanced-actions>
            <b-button
              :pressed.sync="myToggle"
              variant="light"
              class="btn--smaller btn--x-smaller btn--transparent"
              @click="myToggle ? selectAllBrokers() : deselectAllBrokers()"
            >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
            </b-button
            >
            <b-button
              :pressed.sync="myTogglePO"
              variant="light"
              class="btn--smaller btn--x-smaller btn--transparent"
              @click="myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()"
            >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
            </b-button
            >
          </template>
        </base-select>
      </div>

      <b-button
        @click="handleSubmit(onGenerate)"
        type="button"
        variant="primary"
        size="sm"
        class="mt-2 ml-4 float-right"
        :disabled="invalid"
      >
        Avvia
      </b-button>
    </validation-observer>
  </b-modal>
</template>
<script>
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseIcon from "@/components/BaseIcon";
import {mapGetters} from "vuex";
import moment from "moment";

moment.locale("it");

export default {
  data() {
    return {
      myToggle: false,
      myTogglePO: false,
      salesmen_taggable: true,
      salesmen: [],
      salesmen_ordered: [],
      salesmen_select: [],
      form: {
        from: null,
        to: null,
        broker: [],
      },
    };
  },
  props: {
    id: {
      type: String,
      default: "generateBrokerStatementModal",
    },
    value: null,
    title: String,
    header: String,
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    BaseSelect,
    BaseDatepicker,
    BaseIcon,
  },
  methods: {
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    onGenerate() {
      const form = JSON.parse(JSON.stringify(this.form));
      this.$emit("generate", form);
      this.close();
    },
    selectAllBrokers() {
      this.form.broker = this.getSalesmen().map((salesman) => salesman.value);
    },
    deselectAllBrokers() {
      this.form.broker = [];
    },
    close() {
      Object.keys(this.form).forEach((key) => (this.form[key] = null));
      this.myToggle = false;
    },
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
    }),
  },
  created() {
    this.salesmen = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.salesmen_select = this.salesmen;
  },
};
</script>
